import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { FormattedMessage } from 'react-intl';
import { MessageDescriptorPropType } from '../../../prop-types/intl';

const ITNOrUSPSDropdownItem = ({ option, onClick, selected, emptyMessageReplacement }) => {
  const onOptionClicked = useCallback(() => {
    onClick(option.value);
  }, [onClick, option.value]);

  return (
    <DropdownMenuItem key={option.value} onClick={onOptionClicked} selected={selected}>
      {!option.messageDescriptor ? emptyMessageReplacement : <FormattedMessage {...option.messageDescriptor} />}
    </DropdownMenuItem>
  );
};

ITNOrUSPSDropdownItem.propTypes = {
  option: PropTypes.shape({
    value: PropTypes.string,
    messageDescriptor: MessageDescriptorPropType,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  emptyMessageReplacement: PropTypes.object.isRequired,
};

export default ITNOrUSPSDropdownItem;
